module.exports = __webpack_public_path__ + "static/media/klaudia.9c68b246.jpg";